/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { API } from 'modules/transactions/constants';
import { transactionActions } from './slice';
/**
 * Embed token generator function for Power BI embedding
 * @param {*} param0
 */
export function* getEmbedTokenGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_EMBED_TOKEN, payload);
    yield put(transactionActions.getEmbedTokenSucceeded(response));
  } catch (error) {
    yield put(transactionActions.getEmbedTokenFailed(error?.message));
  }
}
/**
 * Power BI visual generator function to obtain registered visuals
 * @param {*} param0
 */
export function* getVisualsGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_VISUALS, payload);
    yield put(transactionActions.getVisualsSucceeded(response));
  } catch (error) {
    yield put(transactionActions.getVisualsFailed(error?.message));
  }
}
/**
 * Power BI visual filter generator function to obtain registered visual filters
 * @param {*} param0
 */
export function* getVisualFiltersGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_VISUAL_FILTERS, payload);
    yield put(transactionActions.getVisualFiltersSucceeded(response));
  } catch (error) {
    yield put(transactionActions.getVisualFiltersFailed(error?.message));
  }
}
/**
 * Breakdown data generator function to obtain data for breakdown dropdown
 * @param {*} param0
 */
export function* getBreakdownGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_ALL_BREAKDOWNS, payload);
    yield put(transactionActions.getBreakdownSucceeded(response));
  } catch (error) {
    yield put(transactionActions.getBreakdownFailed(error?.message));
  }
}
/**
 * All hotels force fetch generator function to obtain the list of all registered hotels
 * @param {*} param0
 */
export function* getAllHotelsListGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_ALL_HOTELS, payload);
    yield put(transactionActions.getAllHotelListSucceeded(response));
  } catch (error) {
    yield put(transactionActions.getAllHotelListFailed(error?.message));
  }
}
/**
 * Get latest updated hotels generator function to obtain the list of latest updated hotel list
 * @param {*} param0
 */
export function* getLatestUpdatedAHotelsGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_ALL_HOTELS, payload);
    yield put(transactionActions.getLatestUpdatedHotelListSucceeded(response));
  } catch (error) {
    yield put(transactionActions.getLatestUpdatedHotelListFailed(error?.message));
  }
}
//
export function* transactionSaga() {
  yield takeLatest(transactionActions.getEmbedToken.type, getEmbedTokenGenerator);
  yield takeLatest(transactionActions.getVisuals.type, getVisualsGenerator);
  yield takeLatest(transactionActions.getVisualFilters.type, getVisualFiltersGenerator);
  yield takeLatest(transactionActions.getBreakdown.type, getBreakdownGenerator);
  yield takeLatest(transactionActions.getAllHotelList.type, getAllHotelsListGenerator);
  yield takeLatest(
    transactionActions.getLatestUpdatedHotelList.type,
    getLatestUpdatedAHotelsGenerator
  );
}
export default transactionSaga;
